import type { ComponentProps } from "react"

export default function ZoningCompliance(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 11.25V1.5C13.5 1.5 11.25 0 6.75 0C2.25 0 0 1.5 0 1.5V11.25L6.75 16.5L13.5 11.25ZM5.34779 10.6726L11.6478 4.37264L10.8523 3.57715L4.95004 9.4794L2.64779 7.17715L1.85229 7.97264L4.5523 10.6726C4.77196 10.8923 5.12812 10.8923 5.34779 10.6726Z"
        fill={fill}
      />
    </svg>
  )
}
